import { render, staticRenderFns } from "./Custom_module.vue?vue&type=template&id=070998ec"
import script from "./Custom_module.vue?vue&type=script&lang=js"
export * from "./Custom_module.vue?vue&type=script&lang=js"
import style0 from "./Custom_module.vue?vue&type=style&index=0&id=070998ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports